import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { fetchSimplifiedProducts } from '../../actions/products_actions';

import VendorBatches from '../../components/Inventories/vendorBatches';

function mapStateToProps(state) {
  return {
    vendorBatchesIsLoading: state.vendors.vendorBatchesIsLoading,
    vendorBatchesError: state.vendors.vendorBatchesError,
    vendorBatches: state.vendors.vendorBatches,
  };
}

const vendorBatches = reduxForm({
  form: 'vendorBatches',
  destroyOnUnmount: false,
})(VendorBatches);

export default connect(mapStateToProps, { fetchSimplifiedProducts })(vendorBatches)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/vendorBatches.jsx